import script from "./NamespaceDeleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NamespaceDeleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./NamespaceDeleteModal.vue?vue&type=style&index=0&id=86e7a93e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86e7a93e"]])

export default __exports__